import React from "react";
import Lottie from "lottie-react";
import pulse from "./Pulse.json";

const Pulse = () => (
  <Lottie
    animationData={pulse}
    loop
    style={{ width: 116, position: "absolute" }}
  />
);

export default Pulse;
